<div class="add-container">
    <h1 class="add-title">Adaugă modul</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Modul</mat-label>
                    <mat-select formControlName="module_id">
                        <mat-option *ngFor="let module of modulesActive$ | async" [value]="module.id">
                            {{ module.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Nume afișat</mat-label>
                    <input type="text" matInput formControlName="display_name" />
                    <mat-error *ngIf="!form.controls['display_name'].valid && form.controls['display_name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>URL Front-End</mat-label>
                    <input type="text" matInput formControlName="url_front_end" />
                    <mat-error *ngIf="!form.controls['url_front_end'].valid && form.controls['url_front_end'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col add-field">
                <mat-form-field appearance="fill">
                    <mat-label>URL Back-End</mat-label>
                    <input type="text" matInput formControlName="url_back_end" />
                    <mat-error *ngIf="!form.controls['url_back_end'].valid && form.controls['url_back_end'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="add-action-btns">
            <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                {{ helper.dialogConfig.buttonLabels.close }}
            </button>
            <button class="buttons" type="submit" mat-flat-button color="primary">
                {{ helper.dialogConfig.buttonLabels.save }}
            </button>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>